import { make } from "vuex-pathify";
import apiShowcase from "../../api/modules/showcase";

const state = () => ({
  contentShowcase: [],
  statusLoadShowcase: [],
  currentShowcase: {},
  pointAward: localStorage.getItem("totalPoint"),
  myListAward: JSON.parse(localStorage.getItem("myListAward")) || [],
  myListTitle: [],
  myAnchorTilte: localStorage.getItem("myAnchorTilte") || null,
});

const getters = make.getters(state);

const actions = {
  async getAllShowcase({ commit }, params) {
    try {
      commit("SET_STATUS_LOAD_SHOWCASE", 0);
      let res = await apiShowcase.apiGetAllShowcase(params);
      let data = null;
      if (res.data && res.data.code === 0) {
        data = res.data.result;
        commit("SET_CONTENT_SHOWCASE", data);
        commit("SET_STATUS_LOAD_SHOWCASE", 1);
      } else {
        commit("SET_CONTENT_SHOWCASE", []);
        commit("SET_STATUS_LOAD_SHOWCASE", -1);
      }
    } catch (err) {
      commit("SET_CONTENT_SHOWCASE", []);
      commit("SET_STATUS_LOAD_SHOWCASE", -1);
    }
  },
  async getDetailShowcase({ commit }, showcaseId) {
    try {
      let res = await apiShowcase.apiGetDetailShowcase(showcaseId);
      let data = null;
      if (res.data && res.data.code === 0) {
        data = res.data.result;
        commit("SET_CURRENT_SHOWCASE", data);
        return data;
      } else {
        commit("SET_CURRENT_SHOWCASE", {});
      }
    } catch (err) {
      commit("SET_CURRENT_SHOWCASE", {});
    }
  },

  async redeemAward({ commit }, award) {
    try {
      commit("ADD_POINT_AWARD", award);
      commit("ADD_MY_AWARD", award);
    } catch (err) {
      console.log(err);
      commit("SET_POINT_AWARD", 0);
    }
  },
  async setListTitle({ commit }, listTitle) {
    try {
      commit("SET_MY_LIST_TITLE", listTitle);
    } catch (err) {
      console.log(err);
      commit("SET_MY_LIST_TITLE", []);
    }
  },
};

const mutations = {
  ...make.mutations(state),
  ADD_MY_AWARD(state, award) {
    state.myListAward.push(award);
    console.log(state.myListAward);
    localStorage.setItem("myListAward", JSON.stringify(state.myListAward));
  },
  ADD_POINT_AWARD(state, award) {
    state.pointAward = state.pointAward - award.point;
    localStorage.setItem("totalPoint", state.pointAward);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
